export interface Project {
  customerID: number;
  officeID: number;
  projectID: number;
  customerName: string;
  officeName: string;
  projectName: string;
  projectDescription: string;
  projectCode: string;
  stateName: string;
  city: string;
  muncipalityNames: string;
  countyName: string;
  region: string;
  zipcode: string;
  municipalities: string;
  projectContactsCount: number;
  unitsCount: number;
  projectStatus: string;
  projectType: string;
  subtypeNames: string;
  projectTypeName: string;
  projectCommunityType: string;
  projectLotType: string;
  createdOnText: string;
  rebates: string;
  rebateCompanies: any[];
  rebateCompanyNames: any;
  projectCoordinators: any[];
  projectBuildings: any[];
  planReviews: any[];
  planReviewNames: string;
  contactsCount: number;
  plansCount: number;
  workOrderCount: number;
  builderCode: string;
  feeOwner: string;
  isCompleted: boolean;
  street: string;
  projectContacts: any[];
  syncWithDux: boolean;
  isDuxSyncSuccess: boolean;
  forecastStartDate: string;
  estimatedStartsPerMonth: number;
  projectSyncWithDUX: boolean;
  departmentName: any;
}

export enum ProjectType {
  Residential = 'RES',
  ResidentialSingleLot = 'RES_SL',
  ResidentialCommunity = 'RES_COMTY',
  CommunityMultipleLot = 'COMTY_ML',
  CommunityScatteredLot = 'COMTY_SCT',
  Buildings = 'BLDG',
  Commercial = 'COMRL',
  TimeAndMaterial = 'TML',
}
